<template>
  <div class="">
    <top-header
      :type="3"
      :isShow="false"
      :bgColor="bgColor"
      :textColor="textColor"
    />
    <div class="top_banner" ref="topBanner">
      <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
        <swiper-slide v-if="videoList.length">
          <swiper class="swiper vertical" :options="swiperOptionv">
            <swiper-slide
              class="slide_video_con"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <div class="cover m_flex_box flex_hc flex_vc" @click="showModel">
                <van-icon name="play-circle-o" />
              </div>
              <img :src="imgPath + 'sVideo/' + item.imgId + '.jpg'" alt="" />
            </swiper-slide>
          </swiper>
        </swiper-slide>
        <swiper-slide>
          <swiper class="swiper vertical" :options="swiperOptionv">
            <swiper-slide
              class="slide_video_con"
              v-for="(item, index) in swiperImg"
              :key="index"
            >
              <img
                @click="showModel"
                :src="imgPath + 'sImgMax/' + item.imgid + '.jpg'"
                alt=""
              />
            </swiper-slide>
            <swiper-slide v-if="!videoList.length && !swiperImg.length">
              <img v-lazy="" alt="" />
            </swiper-slide>
          </swiper>
        </swiper-slide>
      </swiper>
      <div class="total">共{{ swiperImg.length + videoList.length }}张</div>
      <div class="pagination m_flex_box flex_vc flex_hc">
        <span
          v-if="videoList.length"
          :class="topSwiperIndex === 0 ? 'active' : ''"
          @click="toSlide(0)"
          >视频</span
        >
        <span :class="topSwiperIndex === 1 ? 'active' : ''" @click="toSlide(1)"
          >图片</span
        >
      </div>
    </div>
    <div class="top_info">
      <div class="m_flex_box flez_vc flex_jz top">
        <h3 class="line_comp1">{{ obj.tgmc ? obj.tgmc : "-" }}</h3>
        <p class="price"></p>
      </div>
      <div class="m_flex_box flex_vc flex_jz">
        <div class="score m_flex_box flex_vc">
          <img
            src="@/assets/img/star.png"
            alt=""
            v-for="item in obj.zScore"
            :key="item"
          />
          <img
            src="@/assets/img/star_.png"
            v-for="item in 5 - zScore"
            :key="item + '_'"
            alt=""
          />
          <span>{{ obj.zScore ? obj.zScore : 0 }}分</span>
        </div>
        <p class="fwl">
          浏览量<span>{{ obj.fwl || 0 }}</span>
        </p>
      </div>
      <div class="icon m_flex_box flex_vc">
        <span>{{ obj.xsqkStr ? obj.xsqkStr : "-" }}</span>
        <div v-for="(item, index) in obj.xmts" :key="index">
          <p v-if="index < 4">
            <i>{{ item }}</i>
          </p>
        </div>
      </div>
    </div>
    <div class="text_con">
      <p class="row m_flex_box flex_vc">
        备案名称<span class="line_comp1">{{ obj.xmmc || "-" }}</span>
      </p>
      <div class="m_flex_box flex_vc flex_jz">
        <p class="row m_flex_box flex_vc flex-1">
          最新预售<span class="line_comp1">{{
            obj.kpsj | timeFormat("yyyy-MM-dd")
          }}</span>
        </p>
        <p class="row m_flex_box flex_vc flex-1">
          上房时间<span class="line_comp1">{{
            obj.sfsj | timeFormat("yyyy-MM-dd")
          }}</span>
        </p>
      </div>
      <p class="row m_flex_box flex_vc">
        开发企业<span class="line_comp1">{{ obj.corpName || "-" }}</span>
      </p>
      <p class="row m_flex_box flex_vc">
        售楼处地址<span class="line_comp1">{{ obj.xsdz || "-" }}</span>
      </p>
      <p class="row m_flex_box flex_vc">
        项目地址<span class="line_comp1">{{ obj.xmdz || "-" }}</span>
      </p>
      <router-link :to="'/projectXq?itemId=' + itemId" class="detail_btn"
        >更多详细信息</router-link
      >
    </div>
    <div class="mid_pad" v-show="showPad"></div>
    <div class="detail_nav_bar" :class="showPad ? 'fixed' : ''">
      <span :class="tabIndex === 0 ? 'active' : ''">楼盘首页</span>
      <span @click="toUrl('/projectXq')">楼盘详情</span>
      <span @click="toUrl('/newsList')">楼盘动态</span>
      <span @click="toUrl('/newsList', 1)">楼盘快讯</span>
      <span @click="toUrl('/photo')">楼盘相册</span>
    </div>
    <div class="pad_top_inner"></div>
    <div class="bor_b">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">楼盘简介</h3>
          <router-link
            :to="'/projectXq?type=1&itemId=' + itemId"
            class="arrow m_flex_box flex_vc"
          >
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="text_con line_comp3">{{ obj.ms || "-" }}</div>
      </div>
    </div>
    <div class="bor_b" v-if="newsList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">楼盘新闻</h3>
          <router-link
            :to="'/newsList?type=1&itemId=' + itemId"
            class="arrow m_flex_box flex_vc"
          >
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="news_list">
          <div
            class="inner m_flex_box flex_vc flex_jz"
            v-for="(item, index) in newsList"
            :key="index"
            @click="toNews(item.nrid)"
          >
            <div class="right">
              <p class="tit line_comp2">{{ item.mc }}</p>
              <p class="time m_flex_box flex_vc">
                <i>新闻</i>
                <span>{{ item.creatDate }}</span>
              </p>
            </div>
            <div class="left">
              <img v-lazy="imgPath + 'sImgXw/' + item.imgid + '.jpg'" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_d m_flex_box flex_vc flex_jz">
      <p @click="toPage">查看换新房源</p>
    </div>
    <div class="pad_bottom"></div>
    <div class="load_con m_flex_box flex_vc flex_hc" v-if="isLoading">
      <div class="inner flex_v flex_vc flex_hc ">
        <van-loading />
        <p>加载中...</p>
      </div>
    </div>
  </div>
</template>

<script>
const map1 = require("@/assets/img/map/1.png");
const map2 = require("@/assets/img/map/2.png");
const map3 = require("@/assets/img/map/3.png");
const map4 = require("@/assets/img/map/4.png");
const map5 = require("@/assets/img/map/5.png");
import qs from "qs";
import { ImagePreview } from "vant";
import topHeader from "@/components/header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { mapGetters } from "vuex";
export default {
  name: "ProjectDetail",
  data() {
    return {
      btnDis: false,
      formDate: {
        wname: "",
        wphone: "",
      },
      adviserList: {},
      isLoading: true,
      pic: require("@/assets/img/tx.jpg"),
      bgColor: "transparent",
      textColor: "#fff",
      tabIndex: 0,
      collected: require("@/assets/img/collect_.png"),
      collectNo: require("@/assets/img/collect.png"),
      isCollect: 0,
      topSwiperIndex: 0,
      announceTab: 0,
      scale: 1,
      swiperOptionh: {
        on: {
          slideChangeTransitionStart: (data) => {
            this.topSwiperIndex = data.activeIndex;
          },
        },
        pagination: {},
      },
      swiperOptionv: {},
      zoom: 10,
      markerList: [{ lng: 117.290313, lat: 34.209974 }],
      active: false,
      icon: require("@/assets/img/zulinxiangqing_ditu_icon.png"),
      icon1: map1,
      center: {},
      center1: {},
      options: {},
      local: null,
      keyword: "公交",
      show: false,
      infoPosition: {},
      infoWindow: "",
      zScore: 0,
      nearby: {
        center: {
          lat: 34.209974,
          lng: 117.290313,
        },
        radius: 2000,
      },
      mapList: [],
      offset: { height: -16, width: 0 },
      showPad: false,
      obj: {},
      itemId: "",
      videoList: [], //视频
      swiperImg: [], //轮播图片
      personList: [], //经纪人
      hxList: [], //户型
      oneHouseList: [], //一房一价
      newsList: [], //新闻
      showAnnounce: false,
      showAnnounce1: false,
      checkObj: {},
      checkObj1: {},
      argumentList: [],
      ad: "",
      scoreObj: {
        score2: 0,
        score3: 0,
        score4: 0,
        zScore: 0,
        score1: 0,
      },
      recommendList: [],
      oldList: [],
      nktCurrent: 0,
      hxIndex: 0,
      offsetTop: 0,
    };
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  filters: {
    timeFormat(dates, fmt) {
      if (dates) {
        var date = new Date(dates);
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        var o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
        };
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            var str = o[k] + "";
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
            );
          }
        }
        return fmt;
      } else {
        return "-";
      }
    },
    formatwan(param) {
      if (param >= 10000) {
        return (param / 10000).toFixed(2) + "w";
      } else {
        return param;
      }
    },
  },
  created() {
    this.itemId = this.$route.query.itemId;
  },
  inject: ["reload"],
  mounted() {
    this.getUserByItemId();
    window.addEventListener("scroll", this.handleScroll);
    this.offsetTop = document.querySelector(".detail_nav_bar").offsetTop;
    this.getDetails();
    this.getAllPer();
    this.getOnehouse();
    this.getNews();
  },
  methods: {
    getUserByItemId() {
      this.$request
        .get("erpService/yw/api/customer/getUserByItemId?itemId=" + this.itemId)
        .then((res) => {
          if (res.success) {
            this.adviserList = res.result;
          } else {
            // this.$toast(res.message);
          }
        });
    },
    toPage() {
      this.$router.push({
        path: "/strictSelectionHouseList",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    collectOption() {
      this.$http
        .post(
          "cms/houseCollect/reg/addNewHouseCollect.do",
          qs.stringify({
            itemId: this.itemId,
          })
        )
        .then((res) => {
          this.$toast(res.msg);
          if (res.success) {
            if (res.msg === "已为您成功添加收藏") {
              this.isCollect = 1;
            } else {
              this.isCollect = 0;
            }
          }
        });
    },
    toProject(itemId, old) {
      if (old == 1) {
        this.$router.push({
          path: "/projectDetailIndex",
          query: {
            itemId: itemId,
          },
        });
      } else {
        this.$router.push({
          path: "/projectDetail",
          query: {
            itemId: itemId,
          },
        });
      }
    },
    getDetail(itemId, old) {
      if (old == 1) {
        this.$router.push({
          path: "/projectDetailIndex",
          query: {
            itemId: itemId,
          },
        });
      } else {
        this.$router.push({
          path: "/projectDetail",
          query: {
            itemId: itemId,
          },
        });
        this.reload();
      }
    },

    getDetails() {
      this.$new
        .post(
          "itemInfo/getItemById.do",
          qs.stringify({
            id: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
          })
        )
        .then((res) => {
          var Img = this.logoImg;
          var url = window.location.href;
          var hosts = url.split("/#/")[0]; //获取域名加打包文件夹名称
          var shareImg = hosts.concat("/" + Img);
          this.$share(res.obj.tgmc, res.obj.ms, shareImg);
          this.isLoading = false;
          this.obj = res.obj;
          this.zScore = res.obj.zScore;
          this.center = {
            lng: res.obj.zb.split(",")[0],
            lat: res.obj.zb.split(",")[1],
          };
          this.center1 = {
            lng: res.obj.zb.split(",")[0],
            lat: res.obj.zb.split(",")[1],
          };
          this.zoom = 15;
          this.$set(this.nearby.center, "lng", res.obj.zb.split(",")[0]);
          this.$set(this.nearby.center, "lat", res.obj.zb.split(",")[1]);
          this.videoList = res.obj.video;
          const imgArr = [];
          for (let i = 0; i < res.obj.img.length; i++) {
            for (let j = 0; j < res.obj.img[i].imgList.length; j++) {
              imgArr.push(res.obj.img[i].imgList[j]);
            }
          }
          this.swiperImg = imgArr;
          res.obj.img.forEach((item, index) => {
            if (item.name === "户型效果图") {
              this.hxList = item.imgList || [];
              this.hxIndex = index;
            }
          });
        });
    },
    getBroker() {
      return new Promise((resolve) => {
        this.$http
          .post(
            "cms/broker/permit/getItemBrokerList.do",
            qs.stringify({
              itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
            })
          )
          .then((res) => {
            resolve(res.obj);
          });
      });
    },
    getZy() {
      return new Promise((resolve) => {
        this.$new
          .post(
            "sale/getZygwList.do",
            qs.stringify({
              itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
            })
          )
          .then((res) => {
            resolve(res.obj);
          });
      });
    },
    getAllPer() {
      Promise.all([this.getBroker(), this.getZy()]).then((res) => {
        let newArr = [];
        if (res[0]) {
          newArr = newArr.concat(res[0]);
        }
        if (res[1]) {
          newArr = newArr.concat(res[1]);
        }
        this.personList = newArr;
      });
    },
    getOnehouse() {
      var that = this;
      that.$new
        .post(
          "houseApi/getHouseList.do",
          qs.stringify({
            itemId: that.itemId,
            type: 2,
            order: 1,
            pageSize: 2,
            currPageNo: 1,
            xzqh: that.main.getHostArea(),
          })
        )
        .then((res) => {
          that.oneHouseList = res.obj || [];
        });
    },
    getNews() {
      this.$new
        .post(
          "itemInfo/getItemNewsById.do",
          qs.stringify({
            pageSize: 2,
            currPageNo: 1,
            itemId: this.itemId || "7c2bf0da11494dd798cc447dc3cb2cc8",
          })
        )
        .then((res) => {
          this.newsList = res.obj || [];
        });
    },
    setNkt(index) {
      this.nktCurrent = index;
    },
    confirm(data) {
      this.checkObj = data;
      this.showAnnounce = false;
    },
    confirm1(data) {
      this.checkObj1 = data;
      this.showAnnounce1 = false;
    },
    toNews(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id,
        },
      });
    },
    toImg() {
      this.$router.push({
        path: "/photo",
        query: {
          itemId: this.itemId,
          index: this.videoList.length ? this.hxIndex + 1 : this.hxIndex,
        },
      });
    },
    handler({ BMap, map }) {
      this.map = map;
    },
    infoWindowOpen(e) {
      this.show = true;
    },
    infoWindowClose(e) {
      this.show = false;
    },
    toSlide(index) {
      if (this.videoList.length) {
        this.$refs.mySwiper.$swiper.slideTo(index, 200);
      } else {
        this.$refs.mySwiper.$swiper.slideTo(index - 1, 200);
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (
        scrollTop >
        this.offsetTop - (document.documentElement.clientWidth / 7.5) * 0.9
      ) {
        this.showPad = true;
      } else {
        this.showPad = false;
      }
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = "#000";
        this.bgColor = "#fff";
      } else {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      }
    },
    showModel(parent, index) {
      this.$router.push({
        path: "/photo",
        query: {
          itemId: this.itemId,
        },
      });
    },
    toUrl(path, type) {
      console.log(this.itemId);
      this.$router.push({
        path,
        query: {
          itemId: this.itemId,
          type: type || "",
        },
      });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.load_con {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  font-size: 14px;

  .inner {
    background-color: rgba(0, 0, 0, 1);
    padding: 16px;
    width: 88px;
    max-width: 70%;
    min-height: 88px;
    border-radius: 8px;
  }

  p {
    margin-top: 8px;
  }
}

video {
  height: 5.64rem;
  width: 100%;
  background-color: #000;
}

.top_banner {
  position: relative;
  height: 5.64rem;

  .total {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 0.24rem;
    width: 1.2rem;
    line-height: 0.5rem;
    position: absolute;
    bottom: 0.24rem;
    right: 0.4rem;
    z-index: 9;
    text-align: center;
    border-radius: 0.25rem;
  }

  img {
    height: 5.64rem;
    width: 100%;
  }

  .slide_video_con {
    position: relative;

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5.64rem;
      background-color: rgba(0, 0, 0, 0.3);

      i {
        color: #fff;
        font-size: 1.4rem;
      }
    }
  }
}

.pagination {
  position: absolute;
  z-index: 9;
  bottom: 0.3rem;
  left: 0;
  right: 0;

  span {
    width: 0.76rem;
    line-height: 0.36rem;
    text-align: center;
    font-size: 0.22rem;
    margin: 0 0.1rem;
    background-color: #e6e6e6;
    color: #101010;
    border-radius: 0.18rem;

    &.active {
      background-color: #3072f5;
      color: #fff;
    }
  }
}

.top_info {
  width: 7.04rem;
  margin: 0.34rem auto;

  .top {
    margin-bottom: 0.24rem;
  }

  h3 {
    font-size: 0.38rem;
    font-weight: 800;
    width: 60%;
  }

  .price {
    font-size: 0.24rem;
    white-space: nowrap;

    span {
      color: #ff4532;
      font-size: 0.36rem;
    }
  }

  .score {
    img {
      width: 0.22rem;
      height: 0.22rem;
      margin-right: 0.06rem;
    }

    span {
      margin-left: 0.08rem;
    }
  }

  .fwl {
    font-size: 0.24rem;
    color: #909090;

    span {
      color: #101010;
      margin-left: 0.06rem;
    }
  }

  .icon {
    font-size: 0.22rem;
    margin-top: 0.3rem;

    span,
    i {
      padding: 0 0.1rem;
      line-height: 0.42rem;
      border-radius: 0.02rem;
      display: block;
    }

    span {
      background-color: #3072f5;
      color: #fff;
    }

    i {
      background-color: #ededed;
      margin-left: 0.08rem;
      color: #666;
    }
  }

  .middle_blue {
    margin-top: 0.44rem;
    height: 0.82rem;
    padding: 0 0.22rem;
    background-color: #eef4ff;

    img {
      margin-right: 0.1rem;
    }

    .left {
      img {
        width: 0.26rem;

        span {
          font-size: 0.26rem;

          i {
            font-weight: 800;
            font-size: 0.3rem;
          }
        }
      }
    }

    .right {
      img {
        width: 0.32rem;
        height: 0.3rem;
      }

      span {
        color: #3072f5;
        font-weight: 800;
      }
    }
  }
}

.text_con {
  width: 7.04rem;
  margin: 0 auto;
  font-size: 0.26rem;
  color: #919191;

  span {
    color: #101010;
    max-width: 5.42rem;
    margin-left: 0.2rem;
  }

  .row {
    margin-bottom: 0.2rem;
  }

  .detail_btn {
    display: block;
    background-color: #f3f3f3;
    color: #757575;
    font-size: 0.24rem;
    text-align: center;
    line-height: 0.68rem;
    margin-bottom: 0.32rem;
  }
}

.middle_btn {
  width: 7.04rem;
  padding-bottom: 0.32rem;
  margin: 0 auto;

  div {
    width: 2.26rem;
    height: 0.66rem;
    background-color: #f2f6ff;
    color: #2f72f5;
    font-size: 0.24rem;

    span {
      margin-left: 0.08rem;
    }

    img {
      width: 0.24rem;
    }
  }
}

.detail_nav_bar {
  &.fixed {
    background-color: #fff;
    position: fixed;
    top: 0.9rem;
    left: 0;
    right: 0;
    z-index: 2;
    border-top: 1px solid #e9e9e9;
  }

  white-space: nowrap;
  overflow: scroll;

  span {
    font-weight: 800;
    display: inline-block;
    padding: 0 0.3rem;
    font-size: 0.3rem;
    line-height: 0.9rem;
    position: relative;

    &.active {
      color: #3072f5;
      font-size: 0.32rem;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0.48rem;
        height: 0.04rem;
        background-color: #3072f5;
        border-radius: 0.02rem;
        left: 50%;
        margin-left: -0.24rem;
        bottom: 0.1rem;
      }
    }
  }
}

.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
  padding: 0.4rem 0;

  .tit_con {
    margin-bottom: 0.28rem;
  }

  .inner_tit {
    font-size: 0.34rem;
    font-weight: 800;
  }

  .arrow {
    color: #aaabae;
    font-size: 0.24rem;

    i {
      margin-left: 0.12rem;
    }
  }

  .text_con {
    line-height: 0.42rem;
  }
}

.news_list {
  .inner {
    padding: 0.3rem 0;
    border-bottom: 1px solid #f4f4f4;

    &:last-child {
      padding: 0.3rem 0 0;
      border: 0;
    }

    .right {
      width: 4.46rem;

      .tit {
        color: #202020;
        font-size: 0.28rem;
        margin-bottom: 0.2rem;
        line-height: 0.44rem;
      }

      .time {
        i {
          background-color: #f4f4f4;
          font-size: 0.22rem;
          padding: 0.02rem 0.06rem;
          color: #666;
          border-radius: 0.02rem;
        }

        span {
          color: #999;
          margin-left: 0.1rem;
        }
      }
    }

    .left {
      img {
        width: 2.08rem;
        height: 1.58rem;
      }
    }
  }
}

.ad_con {
  padding-top: 0.3rem;

  img {
    height: 1.68rem;
    width: 100%;
    display: block;
  }
}

.bm-view {
  width: 100%;
  height: 3.88rem;
}

.no_map {
  font-size: 0.24rem;
  font-weight: 600;
  color: #999;
  height: 2rem;
}

.argument_con {
  .argument_top {
    h5 {
      margin-right: 0.12rem;
      font-size: 0.3rem;
      color: #ff2a2a;

      span {
        font-size: 0.32rem;
        font-weight: 800;
      }
    }

    .score_text {
      font-size: 0.24rem;
      margin-top: 0.1rem;
      color: #303030;

      span {
        margin-right: 0.24rem;
      }
    }

    .argument_btn {
      display: block;
      margin-top: 0.4rem;
      background-color: #fff4f2;
      color: #ff5c5c;
      line-height: 0.78rem;
      text-align: center;
    }
  }

  .icon_con {
    img {
      width: 0.26rem;
      margin-right: 0.06rem;
    }
  }
}

.argument_list {
  .row {
    padding: 0.4rem 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: 0;
    }

    .row_top {
      .avatr {
        width: 0.78rem;
        border-radius: 50%;
        margin-right: 0.16rem;
      }

      .top_l_r {
        p {
          font-size: 0.26rem;
          margin-bottom: 0.12rem;
        }
      }

      .time {
        font-size: 0.24rem;
        color: #838383;
      }
    }
  }

  .argumennt_b {
    margin-top: 0.3rem;

    h5 {
      font-size: 0.26rem;
      color: #252525;
      margin-bottom: 0.2rem;
      font-weight: 800;
    }

    .score_text {
      font-size: 0.22rem;
      color: #9a9a9a;

      span {
        margin-right: 0.16rem;
      }
    }

    .img_list {
      img {
        width: 1.6rem;
        height: 1.2rem;
        margin-right: 0.1rem;
      }
    }
  }

  .go_btn {
    display: block;
    background-color: #f1f6ff;
    color: #2f72f5;
    line-height: 0.78rem;
    text-align: center;
  }
}

.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;

  .inner {
    .banner {
      width: 2.44rem;
      height: 1.84rem;
    }

    padding: 0.35rem 0;
    border-bottom: 1px solid #f4f4f4;
  }

  .new_r {
    img {
      width: 100%;
    }

    .tel {
      width: 0.36rem;
      height: 0.36rem;
    }

    width: 4.25rem;
    margin-left: 0.3rem;

    .col_gray {
      font-size: 0.24rem;
      color: #505050;
    }

    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
      }

      i {
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2f72f5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }

      span {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}

.new_list {
  .inner {
    .new_r {
      .col_gray {
        margin: 0.1rem 0;
      }

      .info {
        color: #505050;
        font-size: 0.24rem;

        p {
          margin-right: 0.2rem;
        }

        span {
          color: #ff6a18;
        }
      }

      .col_red {
        margin-top: 0.1rem;

        h4 {
          font-size: 0.36rem;
          font-weight: 800;
        }

        span {
          font-size: 0.22rem;
        }
      }

      .text {
        margin-top: 0.1rem;
        font-size: 0.22rem;
        color: #a0a0a0;

        i {
          font-size: 0.18rem;
        }
      }
    }
  }
}

.footer_d {
  background-color: #fff;
  left: 0;
  right: 0;
  position: fixed;
  height: 0.98rem;
  padding: 0 0.12rem;
  bottom: 0;
  border-top: 1px solid #f0f0f0;

  p {
    padding: 0.18rem 0;
    color: #fff;
    width: 60%;
    margin: 0 auto;
    text-align: center;
    border-radius: 10px;
    background: #2a7df9;
  }
}

.pad_bottom {
  padding-top: 0.6rem;
}

.mid_pad {
  padding-top: 0.92rem;
}

.old_list {
  .inner {
    .inner_l {
      position: relative;

      i {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        position: absolute;
        display: block;
        top: 0;
      }
    }

    .new_r {
      .tit {
        margin-bottom: 0.08rem;
      }

      .col_gray {
        margin: 0.04rem 0;
      }

      .price {
        h4 {
          font-size: 0.34rem;
          color: #ff4532;
          margin-bottom: 0;
          font-weight: 800;
        }

        p {
          font-size: 0.24rem;
          color: #aaaaaa;
          margin-left: 0.12rem;
        }
      }

      .num {
        margin-top: 0.04rem;
        color: #3072f5;

        img {
          width: 0.3rem;
          height: 0.3rem;
        }

        span {
          margin: 0 0.1rem;
          color: #383333;
        }
      }
    }
  }
}

.nkt_tab {
  white-space: nowrap;
  margin-bottom: 0.38rem;

  span {
    display: inline-block;
    background-color: #f0f0f0;
    color: #303030;
    line-height: 0.56rem;
    border-radius: 0.28rem;
    padding: 0 0.46rem;
    margin-right: 0.3rem;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      background-color: #e8f0ff;
      color: #2f72f5;
      font-weight: 800;
    }
  }
}
</style>
